import { InjectionToken } from '@angular/core';
import { IPlatformService } from './platform-service.interface';

export const PLATFORM_SERVICE = new InjectionToken<IPlatformService>(
  'PLATFORM_SERVICE'
);
